export default {
  Survey: {
    ChooseLevel: 'Vui lòng chọn số điểm để đánh giá mức độ hài lòng đối với sản phẩm',
    VeryLike: 'Rất hài lòng',
    DisLike: 'Không hài lòng',
    Reason: 'Xin cho biết lý do bạn chưa hài lòng với sản phẩm:',
    CanIHelpU: 'Chúng tôi có thể làm gì để sản phẩm, dịch vụ được tốt hơn?',
    Score: 'Điểm đánh giá',
    ReasonType: 'Loại lý do?',
    Feedback: 'Ý kiến đóng góp thêm (nếu có)?',
    ValidateReason: 'Vui lòng chọn một trong các lý do',
    ValidateFeedback: 'Vui lòng nhập lý do chưa hài lòng về sản phẩm',
    Title: 'Bạn có hài lòng với sản phẩm EMIS Ôn tập không?',
    ThankU: 'Chân thành cảm ơn thầy cô!',
    Description: 'Những chia sẻ của thầy cô sẽ giúp Emis Ôn tập cải tiến sản phẩm',
    Better: 'ngày càng tốt hơn'
  }
}
